export function isBoolean(value: unknown, convert = false): value is boolean {
  if (value == null) return false;
  if (typeof value === 'boolean') return true;
  if (value instanceof Boolean) return value.valueOf() === true || value.valueOf() === false;
  if (!convert) return false;

  if (typeof value === 'string') return value === 'true' || value === 'false';
  if (typeof value === 'number') return value === 0 || value === 1;

  // All other truthy and falsy values are intentionally ignored. Just use an if statement to check for them.
  return false;
}

export function toBoolean(value: unknown, convert = false): boolean | undefined {
  if (value == null) return undefined;
  if (typeof value === 'boolean') return value;
  if (value instanceof Boolean) return value.valueOf();
  if (!convert) return undefined;

  if (typeof value === 'string') {
    if (value === 'true') return true;
    if (value === 'false') return false;
    return undefined;
  }
  if (typeof value === 'number') {
    if (value === 0) return false;
    if (value === 1) return true;
    return undefined;
  }

  // All other truthy and falsy values are intentionally ignored.
  return undefined;
}

/** Converts a value of unknown type to a boolean. An alias for toBoolean() with convert=true. */
export const convertBoolean = (value: unknown): boolean | undefined => toBoolean(value, true);

/**
 * Parses a string into a boolean, with optional normalization.
 *
 * @param value - The string to parse into a boolean
 * @param normalize - Optional function to transform the string before parsing
 * @returns The parsed boolean, or undefined if parsing fails
 */
export function parseBoolean(value?: string, normalize?: (value: unknown) => string): boolean | undefined {
  const normalized = normalize ? normalize(value) : value;
  return toBoolean(normalized, true);
}

// Intentionally did not implement asBoolean() function. If you want coercion just use the 'as' keyword.
